const STORAGE_KEY = 'prairi.pricingSignupDraft';

export type PricingSignupUserType = 'startup' | 'investor';
export type PricingSignupPlan = 'yearly' | 'lifetime' | 'threeYear';

export type PricingSignupDraft = {
  userType: PricingSignupUserType;
  pricingType: PricingSignupPlan;
  name: string;
  email: string;
  country: string;
  hearAboutUs: string;
  agreeToNewsletter: boolean;
  agreeToPrivacyPolicy: boolean;
};

function storage(): Storage | null {
  try {
    if (typeof localStorage === 'undefined') return null;
    return localStorage;
  } catch {
    return null;
  }
}

export function savePricingSignupDraft(draft: PricingSignupDraft): void {
  const store = storage();
  if (!store) return;
  try {
    store.setItem(STORAGE_KEY, JSON.stringify(draft));
  } catch {
    // Private mode / quota — skip persistence.
  }
}

export function loadPricingSignupDraft(userType: PricingSignupUserType): PricingSignupDraft | null {
  const store = storage();
  if (!store) return null;
  try {
    const raw = store.getItem(STORAGE_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw) as Partial<PricingSignupDraft>;
    if (parsed.userType !== userType) return null;
    if (
      parsed.pricingType !== 'yearly' &&
      parsed.pricingType !== 'lifetime' &&
      parsed.pricingType !== 'threeYear'
    ) {
      return null;
    }
    return {
      userType,
      pricingType: parsed.pricingType,
      name: typeof parsed.name === 'string' ? parsed.name : '',
      email: typeof parsed.email === 'string' ? parsed.email : '',
      country: typeof parsed.country === 'string' ? parsed.country : '',
      hearAboutUs: typeof parsed.hearAboutUs === 'string' ? parsed.hearAboutUs : '',
      agreeToNewsletter: parsed.agreeToNewsletter !== false,
      agreeToPrivacyPolicy: parsed.agreeToPrivacyPolicy === true,
    };
  } catch {
    return null;
  }
}

export function clearPricingSignupDraft(): void {
  const store = storage();
  if (!store) return;
  try {
    store.removeItem(STORAGE_KEY);
  } catch {
    // Ignore.
  }
}
